import SubElement from "../../../../../components/categories/siakad/laporan_adab/sub_element/Home";
export default function Home() {
  
  return (
    <SubElement />
  );
}
